import axios from "@/api/config";

let api = {
  campus,
  system,
  student,
  generator,
  generatorProperty,
  generatorRule,
  user,
  role,
  resource,
  schoolPage,
  xiaoETongLiveInfo,// 小鹅通直播js
  minShengCourseInfo,//  民生资源录播、题库、直播js
  dictionary,
  schedule,
  subjectCourse,
  teacher,
  questionType,
  question,
  department,
  chapter,
  scoreRule,
  videoCourse,
  exam,
  examType,
  videoInfo,
  goodsInfo,
  goodsAgentPrice,
  goodsItem,
  questionQuery,
  newsCenter,
  orderInfo,
  agentLevel,
  agentUserInfo,
  agentInfo,
  tencentVideoInfo,
  applyGuide,
  distributionLevel,
  agentGoods,
  rechargeRule,
  fodderGroupInfo,
  attachment,
  videoMaterials,
  log,
  specialExercise,
  dailyExercise,
  specialExerciseQuestion,
  notice,
  template,
  schoolPageMenu,
  schoolPageTemplate,
  versionManagement,
  wxSchoolPage,
  wxSchoolPageTemplate,
  wxSchoolPageMenu,
  agentTouristInfo,
  saleCenter,
  live,
  additionGoodsRelation,
  additionGoods,
  feedback,
  updateUserInfo(data) {
    return axios.post(`${process.env.BASE_URL}/system/updateUserInfo`, data);
  },
  uploadFile(data) {
    return axios.post(`${process.env.BASE_URL}/system/uploadFile`, data);
  },
  getUserInfo(data) {
    return axios.get(`${process.env.BASE_URL}/system/getUserInfo`, {
      params: data
    });
  },
  getSubjectTreeList(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectTreeList`, {
        params: data
      }
    );
  },
  getAlreadyRelateData(data) {
    return axios.post(
      `${process.env.BASE_URL}/goodsInfoSubjectRelation/getGoodsInfoSubjectRelationList`,
      data
    );
  },
  getSubjectCourseTreeList(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectCourseTreeList`, {
        params: data
      }
    );
  },
  getSubjectCourseAllTree(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectCourseAllTree`, {
        params: data
      }
    );
  },
  addQuestionBatch(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/addQuestionBatch`,
      data
    );
  },
  relateGoodsById(data) {
    return axios.post(
      `${process.env.BASE_URL}/goodsInfoSubjectRelation/manageGoodsInfoSubjectRelationList`,
      data
    );
  },
  addQuestionBatchChapter(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/addQuestionBatchChapter`,
      data
    );
  },
  bindQuestionBatchChapter(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/bindQuestionBatchChapter`,
      data
    );
  },
  addQuestionBatchExam(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/addQuestionBatchExam`,
      data
    );
  },
  bindQuestionBatchExam(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/bindQuestionBatchExam`,
      data
    );
  },

  bindQuestionBatchSpecial(data) {
    return axios.post(
      `${process.env.BASE_URL}/specialExerciseQuestion/bindQuestion`,
      data
    );
  },

  deleteSpecialExerciseQuestion(data) {
    return axios.delete(
      `${process.env.BASE_URL}/specialExerciseQuestion/deleteSpecialExerciseQuestion`, {
        data: data
      }
    );
  },

  addNews(data) {
    return axios.post(`${process.env.BASE_URL}/news/addNews`, data);
  },
  deleteNews(data) {
    return axios.post(`${process.env.BASE_URL}/news/deleteNews`, data);
  },
  updateNews(data) {
    return axios.post(`${process.env.BASE_URL}/news/updateNews`, data);
  },
  pageListNews(data) {
    return axios.post(`${process.env.BASE_URL}/news/pageList`, data);
  },
  getNewsInfo(data) {
    return axios.get(`${process.env.BASE_URL}/news/getNewsInfo`, {
      params: data
    });
  },
  upload(data) {
    return axios.get(`${process.env.BASE_URL}/upload/stsToken`, {
      params: data
    });
  },
  syncTecentVideo(data) {
    return axios.post(`${process.env.BASE_URL}/fodder/syncTecentVideo`, data);
  },
  getSignature(data) {
    return axios.post(`${process.env.BASE_URL}/fodder/getSignature`, data);
  },
  changeSort(data) {
    return axios.post(`${process.env.BASE_URL}/goodsItem/changeSort`, data);
  }
};
export default Object.assign(api);

import student from "./student";
import system from "./system";
import generator from "./generator";
import generatorProperty from "./generatorProperty";
import generatorRule from "./generatorRule";
import user from "./user";
import role from "./role";
import resource from "./resource";
import dictionary from "./dictionary";
import schoolPage from "./schoolPage";
import schedule from "./schedule";
import subjectCourse from "./subjectCourse";
import teacher from "./teacher";
import questionType from "./questionType";
import question from "./question";
import department from "./department";
import chapter from "./chapter";
import exam from "./exam";
import scoreRule from "./scoreRule";
import videoCourse from "./videoCourse";
import examType from "./examType";
import questionQuery from "./questionQuery";
import newsCenter from "./newsCenter";
import campus from "./campus";
import saleCenter from './saleCenter'
import videoInfo from "./videoInfo";
import goodsInfo from "./goodsInfo";
import goodsAgentPrice from "./goodsAgentPrice";
import goodsItem from "./goodsItem";
import orderInfo from "./orderInfo";
import agentLevel from "./agentLevel";
import agentUserInfo from "./agentUserInfo";
import agentInfo from "./agentInfo";
import tencentVideoInfo from "./tencentVideoInfo";
import applyGuide from "./applyGuide";
import distributionLevel from "./distributionLevel";
import agentGoods from "./agentGoods";
import rechargeRule from "./rechargeRule";
import fodderGroupInfo from "./fodderGroupInfo";
import attachment from "./attachment";
import videoMaterials from "./videoMaterials";
import log from "./log";
import specialExercise from "./specialExercise";
import specialExerciseQuestion from "./specialExerciseQuestion";
import notice from "./notice";
import template from "./template";
import schoolPageMenu from "./schoolPageMenu";
import schoolPageTemplate from "./schoolPageTemplate";
import versionManagement from "./versionManagement";

import wxSchoolPage from "./wxSchoolPage";
import wxSchoolPageMenu from "./wxSchoolPageMenu";
import wxSchoolPageTemplate from "./wxSchoolPageTemplate";
import agentTouristInfo from "./agentTouristInfo";
import xiaoETongLiveInfo from "./xiaoETongLiveInfo";// 小鹅通直播js
import minShengCourseInfo from "./minShengCourseInfo";// 小鹅通直播js

import live from '@/api/live';
import additionGoodsRelation from '@/api/additionGoodsRelation';
import additionGoods from '@/api/additionGoods';
import feedback from "./feedback";
import dailyExercise from "./dailyExercise";



// WEBPACK FOOTER //
// ./src/api/api.js